import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ChevronDownSvg } from './svgs';

export const IconChevronDown: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={ChevronDownSvg} viewBox="0 0 24 24" {...props} />;
};
